
import Vue from 'vue';
import { ValidationObserver } from 'vee-validate';
import { namespace } from 'vuex-class';
import { Component } from 'vue-property-decorator';
import { ENTRY_WIZARD_ENTERPRISE, ENTRY_WIZARD_CONTACT } from '@/router';

import { NAME } from '../store/index';
const modul = namespace(NAME);

//Getters und Actions
import { CASE_FULL_DATA, CASE_LOCAL_UNIT, CASE_ENTERPRISE_UNIT } from '../store/getters';
import {
    ICaseFullDataViewModel,
    CaseStepInfoViewModel,
    ILocalUnitDataObject,
    IEnterpriseUnitDataObject
} from '@/api-viewmodel';
import { LocalStepIndex } from '../views/Wizard.vue';
import StepHeader from './StepHeader.vue';
import LocalUnitEditAddress from './LocalUnitEditAddress.vue';

//Footer-Bar und -Buttons
import { NAME as NAME_FOOTERBAR } from '@/store/modules/footerBar';
const footerBarModul = namespace(NAME_FOOTERBAR);
import { NEW_BUTTON, CLOSE, DISABLE_BUTTONRIGHT } from '@/store/modules/footerBar/actions';
import { FooterButtonType, IFooterButton } from '@/store/modules/footerBar/state';
import { SUBMIT_CASE_STEPINFO } from '../store/actions';

import FooterBarRightButtonProxy from '@/components/FooterBarRightButtonProxy.vue';
@Component({
    components: { StepHeader, LocalUnitEditAddress, FooterBarRightButtonProxy, ValidationObserver }
})

/** LocalUnit-Step im Entry Wizard
 * @remarks Implementiert die
 *  {@link:https://collaboration.nowhow.ch/erst/foswiki/bin/view/Erst/DatenErfassungUnternehmenScreen}
 *  {@link:https://collaboration.nowhow.ch/erst/foswiki/bin/view/Erst/DatenErfassungLocalAdresseScreen}
 *  {@link:https://collaboration.nowhow.ch/erst/foswiki/bin/view/Erst/DatenErfassungLocalCensusScreen}
 */
export default class StepLocal extends Vue {
    //Getters
    @modul.Getter(CASE_FULL_DATA) caseFullData!: ICaseFullDataViewModel;
    @modul.Getter(CASE_LOCAL_UNIT) localUnit!: ILocalUnitDataObject;
    @modul.Getter(CASE_ENTERPRISE_UNIT) enterpriseUnit!: IEnterpriseUnitDataObject;

    //Actions
    @modul.Action(SUBMIT_CASE_STEPINFO) submitStepInfo!: Function;
    @footerBarModul.Action(NEW_BUTTON) newFooterBar!: Function;
    @footerBarModul.Action(CLOSE) closeFooterBar!: Function;
    @footerBarModul.Action(DISABLE_BUTTONRIGHT) disableButtonRight!: Function;

    /** Der aktuell gültige Identifier für den nächsten Detail-Step
     * @remarks Wird nach jeder Änderung der offenen/dargestellten Unit aktualisiert
     */
    private nextUnitIdentifier = undefined;

    mounted() {
        console.debug('StepLocal.vue::mounted');

        //Den aktuellen Step sofort melden
        this.submitStepInfo({
            caseId: this.caseFullData.caseId,
            data: new CaseStepInfoViewModel(LocalStepIndex, null)
        });

        this.showStepNavigation();
    }

    /** Definiert die Wizard-Navigations-Buttons und zeigt diese an
     * @remarks Aktualisiert auch die für die Navigation verwendeten previous/next Identifier
     */
    private showStepNavigation() {
        console.debug('StepLocal.vue::showStepNavigation');
        const buttonLeft: Array<IFooterButton> = [
            {
                onClick: () => {
                    this.gotoPreviousStep();
                },
                label: 'btn_wzrd_back',
                type: FooterButtonType.secondary
            }
        ];
        const buttonRight: Array<IFooterButton> = [
            {
                onClick: () => {
                    this.gotoNextStep();
                },
                label: 'btn_wzrd_next',
                type: FooterButtonType.primary
            }
        ];
        this.closeFooterBar();
        this.newFooterBar({ buttonLeft, buttonRight });
    }

    /** Navigiert zum vorangehenden Step im Entry-Wizard. */
    gotoPreviousStep() {
        this.$router.push({ name: ENTRY_WIZARD_CONTACT });
    }

    /** Navigiert zum nächsten Step im Entry-Wizard. */
    gotoNextStep() {
        console.debug('StepLocal.vue::gotoNextStep');

        this.$router.push({ name: ENTRY_WIZARD_ENTERPRISE });
    }
}
